import React, { PureComponent } from 'react';
import { filterRange, filterMaxPoints } from './utils';
import memoize from 'memoize-one';

// Components

interface ChartPathProps {
  points: [number, number][];
  width: number;
  height: number;
  range: [number, number];
  maxPoints?: number;
}
export default class ChartPath extends PureComponent<ChartPathProps> {
  _points = memoize((points, max) => {
    return max ? filterMaxPoints(points, max) : points;
  });

  get points(): [number, number][] {
    let { points, maxPoints } = this.props;
    return this._points(points, maxPoints);
  }
  render() {
    const { color, width, height, range } = this.props;
    const d = this.points.map(
      ([x, y]) =>
        `L${((x - range[0]) / (range[1] - range[0])) * width} ${height - (y || 0) * height}`
    );
    if (d.length) d[0] = 'M' + d[0].substr(1);

    return (
      <path
        d={d.join('')}
        stroke={color}
        strokeWidth={1.5}
        fill="transparent"
      />
    );
  }
}
